import {
	defineCustomClientStrategy,
	defineCustomServerStrategy,
	extractLocaleFromCookie
} from '$lib/paraglide/runtime';
import { isAppAreaPath, localeFromCookieHeader } from './app-locale';

/**
 * SAM-836: custom paraglide strategy placed BEFORE `url` in the strategy
 * chain (see vite.config.ts, mirrored by the CI compile flag). In the app
 * area it resolves the locale from the preference cookie; everywhere else it
 * returns undefined so marketing keeps its URL-driven behavior. Without it,
 * the `url` strategy resolves every unprefixed URL to the base locale ("en"),
 * which reverted the user's language on each in-app navigation.
 */
export const APP_COOKIE_STRATEGY = 'custom-appCookie';

/** Register on the client (hooks.client.ts) before anything renders. */
export function registerAppCookieClientStrategy(): void {
	defineCustomClientStrategy(APP_COOKIE_STRATEGY, {
		getLocale: () =>
			isAppAreaPath(window.location.pathname) ? extractLocaleFromCookie() : undefined,
		// Persistence is handled by the `cookie` strategy later in the chain.
		setLocale: () => {}
	});
}

/** Register on the server (hooks.server.ts) before paraglideMiddleware runs. */
export function registerAppCookieServerStrategy(): void {
	defineCustomServerStrategy(APP_COOKIE_STRATEGY, {
		getLocale: (request?: Request) =>
			request && isAppAreaPath(new URL(request.url).pathname)
				? localeFromCookieHeader(request.headers.get('cookie'))
				: undefined
	});
}
